<template>

    <div class="container-fluid ps-5" data-html2canvas-ignore="true">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <section class="">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <h1 class="thin-text mb-5 fs-3">Il tuo progetto di vita</h1>
                </div>
            </div>
        </div>
        <div class="container mb-5">
            <div class="row justify-content-center">
                <div  class="col-2 text-center d-flex flex-column align-items-center" v-for="eventType in this.formData.eventTypes" >
                    <img v-if="eventType == 'Prima casa'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/prima-casa.png" alt="">
                    <img v-if="eventType == 'Diploma'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/diploma.png" alt="">
                    <img v-if="eventType == 'Laurea'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/laurea.png" alt="">
                    <img v-if="eventType == 'Matrimonio'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/matrimonio.png" alt="">
                    <img v-if="eventType == 'Nascita primo figlio/a'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/nascita.png" alt="">
                    <img v-if="eventType == 'Età importante'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/1/eta.png" alt="">
                    <img v-if="eventType == 'Seconda casa'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/2/seconda-casa.png" alt="">
                    <img v-if="eventType == 'Auto'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/2/auto.png" alt="">
                    <img v-if="eventType == 'Barca'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/2/barca.png" alt="">
                    <img v-if="eventType == 'Credito'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/2/reddito.png" alt="">
                    <img v-if="eventType == 'Altro'" class="img-fluid mb-3 w-75" src="../../assets/realizzare-screen/2/altro.png" alt="">                      
                    <span class="thin-text" v-if="eventType != 'Altro'">{{eventType}} <span v-if="eventType == 'Età importante'">{{formData.eventAge}}</span> </span>
                    <span class="thin-text" v-if="eventType == 'Altro'">{{formData.eventOther}} </span>
                </div>
                
            </div>
        </div>
         <div class="custom-container">
            <div class="row">
                <h5 class="thin-text mb-4">I numeri del tuo piano</h5>
                
                <div class="col-6">
                    <div class="card card-highlight mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{formData.amountAnnual.toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</h6>
                        <p class="card-text text-center small mb-0">Importo annuo premio ricorrente</p>
                        </div>
                    </div>
                    <div class="card card-highlight mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{ (formData.deathCoverageCalculated).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</h6>
                        <p class="card-text text-center small mb-0">Premio annuo assic. in caso di morte</p>
                        </div>
                    </div>
                    <div class="card card-highlight mb-5">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{ (formData.diseaseCoverageCalculated).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</h6>
                        <p class="card-text text-center small mb-0">Premio annuo assic. critical illness</p>
                        </div>
                    </div>
                    
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{formData.contractFigure.firstName}} {{formData.contractFigure.lastName}}</h6>
                        <p class="card-text text-center small mb-0">Contraente</p>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{ formData.contractFigure.email }} </h6>
                        <p class="card-text text-center small mb-0">Contraente Email</p>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{formData.contractFigure.address}}</h6>
                        <p class="card-text text-center small mb-0">Contraente Indirizzo</p>
                        </div>
                    </div>
                    
                    <div v-if="formData.deathCoverage || formData.diseaseCoverage">
                        <hr>
                        <div class="card mb-3">
                            <div class="card-body">
                            <h6 class="card-title text-center m-0">{{formData.insuredFigure.firstName}} {{formData.insuredFigure.lastName}}</h6>
                            <p class="card-text text-center small mb-0">Assicurato</p>
                            </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-body">
                            <h6 class="card-title text-center m-0">{{ formData.insuredFigure.email }} </h6>
                            <p class="card-text text-center small mb-0">Assicurato Email</p>
                            </div>
                        </div>
                        <div class="card mb-3" v-if="formData.deathCoverage || formData.diseaseCoverage">
                            <div class="card-body">
                            <h6 class="card-title text-center m-0">{{ formData.insuredFigure.address }} </h6>
                            <p class="card-text text-center small mb-0">Assicurato Indirizzo</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <div class="col-6" >
                    <div class="card card-highlight mb-3 ">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{formData.duration}} anni</h6>
                        <p class="card-text text-center small mb-0">Durata piano di versamenti</p>
                        </div>
                    </div>
                    <div class="card card-highlight mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{formData.installmentType}}</h6>
                        <p class="card-text text-center small mb-0">Rateazione premio ricorrente</p>
                        </div>
                    </div>
                    <div class="card card-highlight mb-5">
                        <div class="card-body">
                            <h6 class="card-title text-center m-0">{{(formData.installmentAmount + formData.deathCoverageTotal + formData.diseaseCoverageTotal).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</h6>
                            <p class="card-text text-center small mb-0">Premio di perfezionamento</p>
                            
                        </div>
                    </div>
                    
                     
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{moment(formData.contractFigure.dateOfBirth).format('D/MM/YYYY')}}</h6>
                        <p class="card-text text-center small mb-0">Contraente Data di nascita</p>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{ formData.contractFigure.telephone }} </h6>
                        <p class="card-text text-center small mb-0">Contraente Telefono</p>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                        <h6 class="card-title text-center m-0">{{ formData.firstName ? formData.firstName : 'Te stesso'}}</h6>
                        <p class="card-text text-center small mb-0">A chi è rivolto il piano</p>
                        </div>
                    </div>
                    
                    <div v-if="formData.deathCoverage || formData.diseaseCoverage">
                        <hr>
                        <div class="card mb-3">
                            <div class="card-body" v-if="formData.deathCoverage || formData.diseaseCoverage">
                            <h6 class="card-title text-center m-0">{{moment(formData.insuredFigure.dateOfBirth).format('D/MM/YYYY')}}</h6>
                            <p class="card-text text-center small mb-0">Assicurato Data di nascita</p>
                            </div>
                        </div>
                        <div class="card mb-3" v-if="formData.deathCoverage || formData.diseaseCoverage">
                            <div class="card-body">
                            <h6 class="card-title text-center m-0">{{ formData.insuredFigure.telephone }} </h6>
                            <p class="card-text text-center small mb-0">Assicurato Telefono</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                            <h6 class="card-title text-center m-0">{{ formData.beneficiaryFigure.firstName}} {{formData.beneficiaryFigure.lastName}}</h6>
                            <p class="card-text text-center small mb-0">Benificiario</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div> 
    </section>
    <div class="my-5 d-flex flex-column justify-content-center align-items-center" data-html2canvas-ignore="true">
        <div class="text-center" data-html2canvas-ignore="true">
            <input @click="startPdfDownload();" type="submit"  value="Stampa il report">
        </div>
        <div v-if="showLoader" class="my-3 spinner-border red" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <!-- PDF Print -->
    <div class="container-fluid d-flex justify-content-center mb-5 d-none">
        <section id="pdf" class="thin-text">
            <div style="height:1040px; width: 640px" class="print d-flex flex-column justify-content-between">
                <div>
                    <div class="d-flex justify-content-between align-items-center">
                        <img src="../../assets/bg-vita-logo.png" class="object-fit-contain" height="25" alt="">
                        <img src="../../assets/bg-insieme-logo.png" height="45" alt="">
                        <img src="../../assets/bg-private-logo.png"  height="30" alt="">
                    </div>
                    <div class="mx-5">
                        <p class="mb-0 pt-4 fs-1 red">Il tuo progetto di vita</p>
                        <hr class="my-2">
                        <div v-for="eventType in this.formData.eventTypes" class="fs-0">-
                            <span class="ms-5" v-if="eventType != 'Altro'">{{eventType}} <span v-if="eventType == 'Età importante'">{{formData.eventAge}}</span> </span>
                            <span class="ms-5" v-if="eventType == 'Altro'">{{formData.eventOther}} </span>
                        </div>
                    </div>
                    <div class="mx-5">
                        <p class="mb-0 pt-3 fs-1 red">Il numeri del tuo piano</p>
                        <hr  class="my-2">
                        <div class="fs-0 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{formData.amountAnnual.toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</span>
                            <span class="ms-5 small mb-0">Importo annuo ricorrente</span>
                        </div>
                        <div class="fs-0 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{formData.deathCoverageCalculated.toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</span>
                            <span class="ms-5 small mb-0">Premio annuo assic. in caso di morte</span>
                        </div>
                        <div class="fs-0 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{formData.diseaseCoverageCalculated.toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</span>
                            <span class="ms-5 small mb-0">Premio annuo assic. critical illness</span>
                        </div>
                        <div class="fs-0 mt-3 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{formData.duration}} anni</span>
                            <span class="ms-5 small mb-0">Durata piano di versamenti</span>
                        </div>
                        <div class="fs-0 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{formData.installmentType}}</span>
                            <span class="ms-5 small mb-0">Rateazione premio ricorrente</span>
                        </div>
                        <div class="fs-0 d-flex">
                            -
                            <span class="ms-5 fixed-indent">{{(formData.installmentAmount + formData.deathCoverageTotal + formData.diseaseCoverageTotal).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</span>
                            <span class="ms-5 small mb-0">Premio di perfezionamento</span>
                        </div>
                    </div>
                    <div class="mx-5 extra-info-section">
                        <hr class="mt-3">
                        <div class="row">
                            <div class="col-6">
                                <div>
                                    <p class="small bold-text gray-400 m-0">Contraente</p>
                                    <p class="fs-0">{{formData.contractFigure.firstName}} {{formData.contractFigure.lastName}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Contraente Email</p>
                                    <p class="fs-0">{{formData.contractFigure.email}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Contraente Indirizzo</p>
                                    <p class="fs-0">{{formData.contractFigure.address}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Contraente Data di nascita</p>
                                    <p class="fs-0">{{moment(formData.contractFigure.dateOfBirth).format('D/MM/YYYY')}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Contraente Telefono</p>
                                    <p class="fs-0">{{formData.contractFigure.telephone}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">A chi è rivolto il piano</p>
                                    <p class="fs-0">{{ formData.firstName ?  formData.firstName : 'Te stesso'}}</p>
                                </div>
                            </div>
                            <div class="col-6">
                                <div>
                                    <p class="small bold-text gray-400 m-0">Assicurato</p>
                                    <p class="fs-0">{{formData.insuredFigure.firstName}} {{formData.insuredFigure.lastName}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Assicurato Email</p>
                                    <p class="fs-0">{{formData.insuredFigure.email}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Assicurato Indirizzo</p>
                                    <p class="fs-0">{{formData.insuredFigure.address}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Assicurato Data di nascita</p>
                                    <p class="fs-0">{{moment(formData.insuredFigure.dateOfBirth).format('D/MM/YYYY')}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Assicurato Telefono</p>
                                    <p class="fs-0">{{formData.insuredFigure.telephone}}</p>
                                </div>
                                <div>
                                    <p class="small bold-text gray-400 m-0">Beneficiario</p>
                                    <p class="fs-0">{{formData.beneficiaryFigure.firstName}} {{formData.beneficiaryFigure.lastName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <page_footer class="mx-5 text-justify very-small"> 
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan. 
                </page_footer> 
            </div>
            
        </section>
    </div>
    
    
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'ResultScreen',
        emits: ['go-to-event', 'go-back-event', 'print'],
        props: {
            showLoader: {
                type: Boolean,
                default(rawProps) {
                    return false
                }
            },
            formData: {
                type: Object,
                default(rawProps) {
                    return { }
                }
            }
        },
        methods: {
            moment(x) {
                return moment(x);
            },
            startPdfDownload() {
                this.$emit('print');
            }
        }
    }
</script>